export interface PasswordRule {
  message: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { message: 'Mínimo de 8 caracteres', test: (p: string) => p.length >= 8 },
  { message: 'Pelo menos uma letra maiúscula', test: (p: string) => /[A-Z]/.test(p) },
  { message: 'Pelo menos uma letra minúscula', test: (p: string) => /[a-z]/.test(p) },
  { message: 'Pelo menos um número', test: (p: string) => /\d/.test(p) },
  { message: 'Pelo menos um caractere especial (!@#$%&*?)', test: (p: string) => /[!@#$%&*?]/.test(p) },
];

export const useValidation = () => {
  const validateEmail = (email: string): string => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return 'Usuário não pode estar vazio';
    if (!emailRegex.test(email)) return 'Formato incorreto';
    return '';
  };

  const validatePassword = (password: string): string => {
    if (!password) return 'Campo obrigatório';
    if (password.length < 6) return 'Mínimo de 6 caracteres';
    return '';
  };

  const validateUsername = (username: string): string => {
    if (!username.trim()) return 'Campo obrigatório';
    if (/\s/.test(username)) return 'O login não pode conter espaços';
    return '';
  };

  const validateNewPassword = (password: string): string[] => {
    return PASSWORD_RULES.filter((rule) => !rule.test(password)).map((rule) => rule.message);
  };

  return { validateEmail, validatePassword, validateUsername, validateNewPassword };
};
